import './RankingParticipants.css';

import React from 'react';
import PropTypes from 'prop-types';
import padStart from 'lodash/padStart';
import noop from 'lodash/noop';
import config from '@config';

import { RankingPropsTypes, ParticipantProps } from '@models/Ranking';

import { CloseOutlined } from '@ant-design/icons';

import { Table, Popconfirm } from 'antd';
import { eventHandler, GAAction } from '@analytics';
import Link from 'redux-first-router-link';

const base = `${config.host}${config.basePath}`;

export const removeParticipantLink =
  (onRemove) =>
  (value, { _id, username, isOwner }) =>
    isOwner ? null : (
      <Popconfirm
        title={`Eliminar ${username}?`}
        placement="left"
        onConfirm={() => onRemove(_id)}
        okText="Si"
        cancelText="No"
      >
        <a style={{ fontWeight: 'bold' }}>
          <CloseOutlined />
        </a>
      </Popconfirm>
    );

export const getColumns = (
  showScoresAndRank,
  showRemoveColumn,
  onRemove = noop
) => {
  let rank = {
    title: '#',
    dataIndex: ParticipantProps.Rank,
    className: 'column-rank',
    width: '60px',
    align: 'left',
    key: 'participant-rank',
    render: (rank) => <span>{rank}</span>,
  };
  let scores = {
    title: 'Puntos',
    dataIndex: ParticipantProps.Score,
    className: 'column-score',
    width: '60px',
    align: 'center',
    key: 'participant-score',
    render: (score) => padStart(score, config.scoreDigits, '0'),
  };

  let username = {
    title: 'Participante',
    dataIndex: ParticipantProps.Username,
    className: 'column-username',
    key: 'participant-username',
    render: (username, { _id, isOwner }) => (
      <Link
        to={['mundial-ideal', _id]}
        style={{ width: '100%' }}
        onClick={eventHandler(GAAction.ClickOnParticipant)}
      >
        <span>{username}</span>
      </Link>
    ),
  };

  let columns = [rank, username, scores];

  return showRemoveColumn
    ? [
        ...columns,
        {
          key: 'participant-remove',
          width: '30px',
          render: removeParticipantLink(onRemove),
        },
      ]
    : columns;
};

export const isMySelf = ({ me }) => (me ? 'me' : '');

export const RankingParticipants = ({
  participants,
  isOwner,
  isPartnerGroup,
  onRemove,
  isWordCupStarted,
}) => (
  <div className="ranking-details-content ranking-container">
    <Table
      showHeader={false}
      columns={getColumns(isWordCupStarted, isOwner && !isPartnerGroup, onRemove)}
      dataSource={participants}
      rowKey={ParticipantProps.Id}
      pagination={false}
      rowClassName={isMySelf}
    />
  </div>
);

RankingParticipants.displayName = 'RankingParticipants';
RankingParticipants.propTypes = {
  ...RankingPropsTypes,
  onRemove: PropTypes.func,
  isOwner: PropTypes.bool,
  isPartnerGroup: PropTypes.bool,
  isWordCupStarted: PropTypes.bool,
};

RankingParticipants.defaultProps = {
  participants: [],
  onRemove: noop,
  isOwner: false,
  isPartnerGroup: false,
  isWordCupStarted: false,
};

export default RankingParticipants;
